module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductDetailImages":{"showMorePictures":"Načíst další fotky ({count})","permanentDiscount":"Trvale nízká cena"}},"de":{"ProductDetailImages":{"showMorePictures":"Weitere Fotos laden ({count})","permanentDiscount":"Dauerhaft niedriger Preis"}},"sk":{"ProductDetailImages":{"showMorePictures":"Načítať ďalšie fotky ({count})"}}}')
  delete Component.options._Ctor
}
